import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import {
  isLoggedUserSelector,
  targetUserIdSelector,
  targetUserSelector,
} from '../../redux/context/selectors';
import {
  careProvidersSelector,
  sendingReqCircleOfCareSelector,
} from '../../redux/board/selectors/circleOfCare';
import {
  canAssignProviderSelector,
  sendingSelector,
} from '../../redux/profiles/selectors';
import withPopoverMenu from '../../hocs/withPopoverMenu';
import { actions as contextActionsActions } from '../../redux/context';
import { actions as reqCircleOfCareActions } from '../../redux/board/reqCircleOfCare';
import { actions as getUserActionsActions } from '../../redux/profiles/get-user';
import { actions as reqAssignProviderActions } from '../../redux/board/reqAssignProvider';
import { actions as removeAssignedProviderActions } from '../../redux/circles/removeAssignedProvider';
import { actions as getAccessLevelsActions } from '../../redux/profiles/getAccessLevels';
import { actions as contextbarActionsActions } from '../../redux/ui/contextbar';
import { actions as getRelationshipPriorityAction } from '../../redux/board/reqRelationshipPriority';
import styles from './style.styl';

const mapStateToProps = state => ({
  profileData: targetUserSelector(state),
  targetUserId: targetUserIdSelector(state),
  genderList: state.data.processedConsts.genderTypes,
  careProviders: careProvidersSelector(state),
  isLoggedUser: isLoggedUserSelector(state),
  loadingProfile: sendingSelector(state),
  loadingCircle: sendingReqCircleOfCareSelector(state),
  canAssignProvider: canAssignProviderSelector(state),
});

const mapDispatchToProps = {
  setTargetUserId: contextActionsActions.setTargetUserId,
  getCircleOfCare: reqCircleOfCareActions.send,
  getUser: getUserActionsActions.send,
  assignProvider: reqAssignProviderActions.send,
  removeAssignedProvider: removeAssignedProviderActions.send,
  getAccessLevels: getAccessLevelsActions.send,
  toggleContextVisibility: contextbarActionsActions.toggleVisibility,
  getRelationshipPriority: getRelationshipPriorityAction.send,
  clearRelationshipPriority: getRelationshipPriorityAction.clear,
};

export const enhance = compose(
  withPopoverMenu,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/enhance.js